import { wrapRootElement as wrap } from "./gatsby-wrapper";

export const wrapRootElement = wrap;
